export default __webpack_public_path__ + "static/media/inactive1.4f803adc.svg";